// Import actual backend interfaces - no more duplicates
import { ISchedulePatternPartial } from '../../../../../../../app/entities/SchedulePattern'
import { IDaySettingPartial } from '../../../../../../../app/entities/DaySetting'

export const getTechniciansWithSchedulingData = (
  locationObjectId: string,
  startDate: string, // YYYY-MM-DD
  endDate: string    // YYYY-MM-DD
) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/location/${locationObjectId}/scheduling-data?startDate=${startDate}&endDate=${endDate}`,
  }
}

export const checkSchedulePatternChanges = (technicianObjectId: string, schedulePatternData: ISchedulePatternPartial) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/schedule-pattern/check`,
    body: schedulePatternData,
  }
}

export const saveSchedulePattern = (
  technicianObjectId: string, 
  schedulePatternData: ISchedulePatternPartial,
  manualOverrides: string[] = [] // YYYY-MM-DD dates user wants to override
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/schedule-pattern/save`,
    body: {
      schedulePattern: schedulePatternData,
      manualOverrides
    },
  }
}

export const simulateSchedulePatternImpact = (technicianObjectId: string, schedulePatternData: ISchedulePatternPartial) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/schedule-pattern/simulate-impact`,
    body: schedulePatternData,
  }
}

export const updateDaySetting = (technicianObjectId: string, daySettingData: IDaySettingPartial, force?: boolean) => {
  const params = force ? '?force=true' : ''
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/day-setting${params}`,
    body: daySettingData,
  }
}

export const getSchedulePatternHistory = (technicianObjectId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/schedule-patterns/history`,
  }
}